import { get, post } from "../config/user-api";

export const User = {
  getSelf: () => get(`user/self`),
};
